import { Injectable, inject } from '@angular/core';
import { combineLatest, interval, of, shareReplay } from 'rxjs';
import { concatMap, map, startWith, tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiConfig } from '@kildenconfig/api-config';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  private _http = inject(HttpClient);
  private lantmeteriet_ticket: string | undefined;
  private nib_token: string | undefined;

  public getTickets() {
    const ticketInt = 3000000; // 50 minutes in milliseconds
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
        'max-age': '0',
      },
    };
    const token = interval(ticketInt).pipe(
      startWith(0),
      concatMap(() =>
        this._http.get(ApiConfig.getTokenUrl, defaultOptions).pipe(
          map((res: any) => {
            if (!res) {
              return null;
            } else {
              return res['token'];
            }
          }),
          catchError(err => {
            console.error('token: henting feilet, prøver igjen om 50 min', err);
            return of(null); // viktig: ikke la feilen drepe interval-strømmen
          })
        )
      )
    );
    const token_nib = interval(ticketInt).pipe(
      startWith(0),
      concatMap(() =>
        this._http.get(ApiConfig.getTokenNibUrl()).pipe(
          map((res: any) => (res ? res['value'] : null)),
          tap(value => {
            if (value) {
              this.nib_token = value;
            } else {
              console.warn('Nib-token: tomt svar, beholder forrige token');
            }
          }),
          catchError(err => {
            console.error('Nib-token: henting feilet, prøver igjen om 50 min', err);
            return of(null); // viktig: ikke la feilen drepe interval-strømmen
          })
        )
      )
    );

    const ticket_lantmeteriet = interval(ticketInt).pipe(
      startWith(0),
      concatMap(() =>
        this._http.get(ApiConfig.ticket_lantmeteriet, defaultOptions).pipe(
          map((res: { [key: string]: any }) => {
            if (!res) return null;

            this.lantmeteriet_ticket = res['ticket'];
            // console.log('this.lantmeteriet_ticket: ', this.lantmeteriet_ticket);
            return res;
          }),
          catchError(err => {
            console.error('Lantmeteriet-ticket: henting feilet, prøver igjen om 50 min', err);
            return of(null); // viktig: ikke la feilen drepe interval-strømmen
          })
        )
      )
    );

    return combineLatest([token, ticket_lantmeteriet, token_nib]);
  }

  getLantmeterietTicket() {
    return this.lantmeteriet_ticket;
  }
  getNibToken() {
    return this.nib_token;
  }
}
